<script setup>
import facebook from '@images/social-media/facebook.png'
import instagram from '@images/social-media/instagram.png'
import linkedin from '@images/social-media/linkedin.png'
import twitter from '@images/social-media/twitter.png'
// import { useHead } from '@vueuse/head'
import Swal from 'sweetalert2'
import { onMounted, reactive } from 'vue'
import { useRoute } from 'vue-router'

import { VForm } from 'vuetify/components/VForm'


const route = useRoute()

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const state = reactive({
  session: {
    text: '',
    image: '',
  },
  baseURL: '',
  imageBaseURL: '',
  windowFeatures: {},
  shareOptions: {
    url: '',
    quote: 'Quote',
    hashtag: '#GitHub',
  },
  useNativeBehavior: false,
})

const refForm = ref()

const textToShare = "Check out this awesome content!"

// const imageUrl = "https://example.com/path-to-your-image.jpg"
const fallbackUrl = "https://example.com/fallback" // Use a generic or less relevant URL
const facebookShareUrl = ref('')

const getSession = async () => {
  try {
    const res = await $api('bot-allocated-text/'+route.params.id, {
      method: 'GET',
      onResponseError({ response }) {
        console.log(response._data.errors)
      },
    })

    console.log(res)
    state.session = res
  } catch (error) {
    console.error('Request failed:', error)
  }
}

const getBaseUrl = async () => {
  try {
    const res = await $api('baseurl', {
      method: 'GET',
      onResponseError({ response }) {
        console.log(response._data.errors)
      },
    })

    state.baseURL = res
  } catch (error) {
    console.error('Request failed:', error)
  }
}

const getImageBaseUrl = async () => {
  try {
    const res = await $api('getImageBaseUrl', {
      method: 'GET',
      onResponseError({ response }) {
        console.log(response._data.errors)
      },
    })

    state.imageBaseURL = res
  } catch (error) {
    console.error('Request failed:', error)
  }
}

const downloadImage = async () => {
  try {
    const response = await $api('download-image/' + route.params.id, {
      method: 'GET',
    })

    const imageData = response.image
    var a  = document.createElement('a')
    a.href = imageData
    a.download = 'image.png'

    a.click()
  } catch (error) {
    console.error('Request failed:', error)
  }
}

const copyLink = async () => {
  var span = document.getElementById('temp-area')
  var x = document.createElement('INPUT')
  x.setAttribute('type', 'text')
  x.setAttribute('id', 'tempInput')
  x.setAttribute('value', state.session.text)
  span.appendChild(x)

  const textToCopy = document.getElementById('tempInput')

  textToCopy.select()
  document.execCommand('copy')

  document.getElementById('tempInput').remove()
  Swal.fire({
    icon: "success",
    title: "Copied",
    showConfirmButton: false,
    timer: 1000,
  })
}

function onClose() {}
function onOpen() {}
function onBlock() {}
function onFocus() {}

// function shareOnFacebook() {
//   var shareUrl = state.baseURL+'/s/text/'+route.params.id
//   const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`

//   window.open(url, '_blank')
// };
// facebookShareUrl.value = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fallbackUrl)}&quote=${encodeURIComponent(textToShare)}&picture=${encodeURIComponent(imageUrl)}`
// function shareOnFacebook() {
//   // facebookShareUrl.value = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fallbackUrl)}`
//   const imageUrl = state.imageBaseURL+'/storage/'+state.session.image;
//   const text = state.session.text;
  
//   const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(imageUrl)}&quote=${encodeURIComponent(text)}`;
  
//   window.open(url, '_blank');
// }



// function shareOnFacebook() {
//     const shareUrl = `${state.baseURL}/share/${route.params.id}`;
//     console.log('shareUrl', shareUrl)
//     const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
//     window.open(url, '_blank');
// }

// function shareOnTwitter() {
//     const shareUrl = `${state.baseURL}/share/${route.params.id}`;
//     const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`;
//     window.open(url, '_blank');
// }

// function shareOnLinkedIn() {
//     const shareUrl = `${state.baseURL}/share/${route.params.id}`;
//     const url = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(shareUrl)}`;
//     window.open(url, '_blank');
// }

const shareOnFacebook = () => {
  const shareUrl = `${state.baseURL}/share/${route.params.id}`;
  const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
  window.open(url, '_blank');
};

const shareOnTwitter = () => {
  const shareUrl = `${state.baseURL}/share/${route.params.id}`;
  const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`;
  window.open(url, '_blank');
};

const shareOnLinkedIn = () => {
  const shareUrl = `${state.baseURL}/share/${route.params.id}`;
  const url = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(shareUrl)}`;
  window.open(url, '_blank');
};
// function shareOnFacebook() {
//   const shareUrl =state.imageBaseURL+'/storage/'+state.session.image;
  
//   const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(state.session.text)}`;
  
//   window.open(url, '_blank');
// }

// function shareOnLinkedIn() {
//   var shareUrl = state.baseURL+'/s/text/'+route.params.id
//   const url = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(state.session.text)}&summary=${encodeURIComponent(state.session.text)}&source=YOUR_SOURCE`

//   window.open(url, '_blank')
// };
// function shareOnTwitter() {
//   var shareUrl = state.baseURL+'/s/text/'+route.params.id
//   const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(state.session.text)}`

//   window.open(url, '_blank')
// };
function shareOnInstagram() {
  // Instagram sharing is more complex and typically done via their app
  alert('Please share this content via the Instagram app.')
};

onMounted(() => {
  getBaseUrl()
  getImageBaseUrl()
  getSession()
})
</script>

<template>
  <VContainer>
    <VForm ref="refForm">
      <VCard class="mb-6">
        <VCardText>
          <VRow>
            <VCol
              cols="12"
              md="12"
            >
              <AppTextarea
                v-model="state.session.text"
                placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam vel faucibus nisi"
              />
            </VCol>
            <VCol
              cols="12"
              md="12"
            >
              <div class="fo-textbtn-area">
                <div id="temp-area" />
                <VBtn @click="copyLink">
                  COPY TEXT
                </VBtn>
                <VImg
                  v-if="state.session.image"
                  :src="state.imageBaseURL+'/storage/'+state.session.image"
                />
                <VBtn
                  v-if="state.session.image"
                  class="fo-grey"
                  @click="downloadImage"
                >
                  DOWNLOAD IMAGE
                </VBtn>
                <!--
                  <a target="_blank":href="state.baseURL+'/storage/'+state.session.image" class="fo-grey">
                  <VImg :src="state.baseURL+'/storage/'+state.session.image" />
                  DOWNLOAD IMAGE
                  </a> 
                -->
              </div>
            </VCol>
            <VCol
              cols="12"
              md="12"
            >
              <div class="fo-social">
                <a
                  href="javascript:void(0);"
                  target="_blank"
                  @click="shareOnFacebook"
                >
                  <VImg :src="facebook" />
                </a> 
               
                <!-- <SFacebook
                  :window-features="state.windowFeatures"
                  :share-options="state.shareOptions"
                  :use-native-behavior="state.useNativeBehavior"
                  @popup-close="onClose"
                  @popup-open="onOpen"
                  @popup-block="onBlock"
                  @popup-focus="onFocus"
                >
                <VImg :src="facebook" />
                </SFacebook> -->

                <a
                  href="javascript:void(0);"
                  @click="shareOnTwitter"
                >
                <VImg :src="twitter" />
                </a>
                <!-- <STwitter
                  :window-features="state.windowFeatures"
                  :share-options="state.shareOptions"
                  :use-native-behavior="state.useNativeBehavior"
                  @popup-close="onClose"
                  @popup-open="onOpen"
                  @popup-block="onBlock"
                  @popup-focus="onFocus"
                >
                <VImg :src="twitter" />
                </STwitter> -->
                <a
                  href="javascript:void(0);"
                  @click="shareOnLinkedIn"
                >
                <VImg :src="linkedin" />
                </a>
                <!-- <SLinkedIn
                  :window-features="state.windowFeatures"
                  :share-options="state.shareOptions"
                  :use-native-behavior="state.useNativeBehavior"
                  @popup-close="onClose"
                  @popup-open="onOpen"
                  @popup-block="onBlock"
                  @popup-focus="onFocus"
                >
                <VImg :src="linkedin" />
                </SLinkedIn> -->
                <a
                  href="javascript:void(0);"
                  @click="shareOnInstagram"
                >
                  <VImg :src="instagram" />
                </a>
              </div>
            </VCol>
          </VRow>
        </VCardText>
      </VCard>
    </VForm>
  </VContainer>
</template>
